/**
 * @generated SignedSource<<00488038f424bfa700fbfa8d0b3932a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Candidate_me$data = {
  readonly email: string | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly profileImage: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "Candidate_me";
};
export type Candidate_me$key = {
  readonly " $data"?: Candidate_me$data;
  readonly " $fragmentSpreads": FragmentRefs<"Candidate_me">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Candidate_me",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "height",
              "value": 50
            },
            {
              "kind": "Literal",
              "name": "width",
              "value": 50
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": "url(height:50,width:50)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Candidate",
  "abstractKey": null
};

(node as any).hash = "bc88e2f8edbc37539025dc6289111d7f";

export default node;
